import type { AnalyticsFlightsAndAppSettings } from 'owa-analytics-types';
import { getApplicationSettings } from 'owa-application-settings';
import { isGulpOrBranching } from 'owa-config';
import { isDataWorkerPlatformEnabled } from 'owa-data-worker-check';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function initializeAnalyticsFlightsAndAppSettings(): AnalyticsFlightsAndAppSettings {
    const isDevEnvironment = isGulpOrBranching();
    const analyticsApplicationSettings = getApplicationSettings('Analytics');

    const settings: AnalyticsFlightsAndAppSettings = {
        // ECS Settings
        disabledDatapoints: analyticsApplicationSettings.disabledDatapoints || [],
        throttledDatapoints: analyticsApplicationSettings.throttledDatapoints || [],
        disableIsCoreDatapoints: analyticsApplicationSettings.disableIsCoreDatapoints || [],
        enableHighCountEventThrottle: analyticsApplicationSettings.enableHighCountEventThrottle,
        highCountEventThrottleWindow: analyticsApplicationSettings.highCountEventThrottleWindow,
        highCountEventThrottleThreshold:
            analyticsApplicationSettings.highCountEventThrottleThreshold,
        capturePerfProfiles: analyticsApplicationSettings.capturePerfProfiles || [],
        maxPerfProfilesPerSession: analyticsApplicationSettings.maxPerfProfilesPerSession,
        // Global flight controls are the sampling source of truth across all
        // apps; getFlightControl uses these when an app omits its own.
        flightControls: analyticsApplicationSettings.flightControls,

        // Feature Flights
        shouldCaptureAssets: isGlobalFeatureEnabled('an-log-assets'),
        skipFlightControls:
            isGlobalFeatureEnabled('ring-dogfood') || isGlobalFeatureEnabled('an-no-sample-ppe'),
        isFullVerboseLoggingEnabled: isGlobalFeatureEnabled('an-full-logging'),
        enablePrivacyGuard: isGlobalFeatureEnabled('fwk-oneDs-privacyGuard'),
        enableSchemaEnforcement: isGlobalFeatureEnabled('fwk-schema-enforcement'),
        turnOffCustomData: isGlobalFeatureEnabled('fwk-turnOffCustomData'),
        devToolsEnabled: isDevEnvironment || isGlobalFeatureEnabled('fwk-devTools'),
        trackEventFrequency: isGlobalFeatureEnabled('fwk-an-trackEventFrquency'),
        isDataWorkerEnabled: isDataWorkerPlatformEnabled(),
        enableOfflineCaching: isGlobalFeatureEnabled('fwk-offline-boot'),
        isDiagDatapointTracingPanelEnabled: isGlobalFeatureEnabled(
            'fwk-diag-datapoint-tracing-panel'
        ),
        enableBackgroundSuccessOnPendingTimeout: isGlobalFeatureEnabled(
            'fwk-an-timeout-background-success'
        ),
        // Kill switch for per-event ECS ETag stamping. Enabling this flight
        // disables the stamping path that powers the IDEAs flight-join lookup.
        disableEcsETagStamping: isGlobalFeatureEnabled('fwk-disable-an-ecs-etag-stamping'),
        // Kill switch for the EcsConfigStateStamping one-shot event.
        // Enabling this flight suppresses emission.
        disableEcsConfigStateStamping: isGlobalFeatureEnabled(
            'fwk-disable-an-ecs-config-state-stamping'
        ),
    };

    return settings;
}
